/**
 * Bottom Navigation Bar
 */

(function() {
  'use strict';

  const bottomNav = document.querySelector('[data-bottom-nav]');
  const cartCount = document.getElementById('bottom-cart-count');

  if (!bottomNav) return;

  // Highlight active page
  function setActivePage() {
    const currentPath = window.location.pathname;
    const navItems = bottomNav.querySelectorAll('[data-nav-item]');

    navItems.forEach(item => {
      const itemType = item.getAttribute('data-nav-item');
      item.classList.remove('active');

      // Check if current page matches this nav item
      if (itemType === 'home' && (currentPath === '/' || currentPath === '')) {
        item.classList.add('active');
      } else if (itemType === 'menu' && currentPath.includes('/collections')) {
        item.classList.add('active');
      } else if (itemType === 'search' && currentPath.includes('/search')) {
        item.classList.add('active');
      } else if (itemType === 'shop' && currentPath.includes('/collections/all')) {
        item.classList.add('active');
      } else if (itemType === 'cart' && currentPath.includes('/cart')) {
        item.classList.add('active');
      } else if (itemType === 'account' && currentPath.includes('/account')) {
        item.classList.add('active');
      }
    });
  }

  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          if (cart.item_count === 0) {
            cartCount.style.display = 'none';
          } else {
            cartCount.style.display = 'block';
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);

  // Initial setup
  setActivePage();
  updateCartCount();

  // Listen for Shopify cart changes
  if (window.Shopify && window.Shopify.onCartUpdate) {
    const originalOnCartUpdate = window.Shopify.onCartUpdate;
    window.Shopify.onCartUpdate = function(cart) {
      if (originalOnCartUpdate) {
        originalOnCartUpdate(cart);
      }
      updateCartCount();
    };
  }

  // Show bottom nav only when scrolled past header
  let ticking = false;

  function updateNavVisibility() {
    const currentScrollY = window.scrollY;

    // Show bottom nav only when scrolled past the header (>100px)
    if (currentScrollY > 100) {
      bottomNav.style.transform = 'translateY(0)';
      bottomNav.style.opacity = '1';
    } else {
      // Hide when at top where main menu is visible
      bottomNav.style.transform = 'translateY(100%)';
      bottomNav.style.opacity = '0';
    }

    ticking = false;
  }

  // Enable show/hide on scroll
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateNavVisibility);
      ticking = true;
    }
  });

  // Initial state - hide if at top
  updateNavVisibility();

  // Connect bottom menu button to mobile menu
  const menuTrigger = document.querySelector('[data-bottom-menu-trigger]');
  const mobileToggle = document.querySelector('[data-mobile-toggle]');

  if (menuTrigger && mobileToggle) {
    menuTrigger.addEventListener('click', function() {
      mobileToggle.click();
    });
  }

})();
